import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	asanaHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-heading',
		defaultMessage: 'Asana',
		description: 'Heading of asana hierarchy',
	},
	jiraHeadingSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-heading-spork',
		defaultMessage: 'Jira',
		description: 'Heading of Jira hierarchy',
	},
	illustrationLabelSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.illustration-label-spork',
		defaultMessage: 'Visualization of how Asana fields are mapped to Jira.',
		description: 'Accessible label for the illustration in project hierarchy',
	},
	asanaSection: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-section',
		defaultMessage: 'Section',
		description: 'text of asana Section',
	},
	asanaTask: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-task',
		defaultMessage: 'Task 1 ',
		description: 'text of example asana Task',
	},
	asanaSubtask: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-subtask',
		defaultMessage: 'Subtask 1',
		description: 'text of example asana Subtask',
	},
	jiraIssueStatus: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-issue-status',
		defaultMessage: 'ISSUE STATUS',
		description: 'text of Jira Issue status',
	},
	jiraIssue: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-issue',
		defaultMessage: 'Issue',
		description: 'text of example Jira Issue',
	},
	jiraSubtask: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-subtask',
		defaultMessage: 'Subtask',
		description: 'text of example Jira Subtask',
	},
});
